import { DisplayUploadStatus, TrackingElements } from '@trackman/baseball-shared-components';
import { ServiceTypes } from 'constants/ServiceTypes';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useInjection } from 'services/ioc/ioc.react';
import { ContextStore } from 'stores/ContextStore';
import { SessionStore } from 'stores/SessionStore';
import { TaggingStore } from 'stores/Tagging/TaggingStore';
import { TrackingElementsStore } from 'stores/TrackingElementsStore';
import VideoUploaderStateStore from 'stores/VideoUploaderStateStore';
import { PlayVideo } from '../PlayVideo/PlayVideo';
import { Wrapper } from './RadarIndicatorStyles';

export const RadarIndicator: React.FC = observer(() => {
  const trackingElementsStore = useInjection<TrackingElementsStore>(ServiceTypes.TrackingElementsStore);
  const sessionStore = useInjection<SessionStore>(ServiceTypes.SessionStore);
  const videoUploaderStateStore = useInjection<VideoUploaderStateStore>(ServiceTypes.VideoUploaderStateStore);
  const taggingStore = useInjection<TaggingStore>(ServiceTypes.TaggingStore);
  const contextStore = useInjection<ContextStore>(ServiceTypes.ContextStore);

  return (
    <Wrapper>
      {(videoUploaderStateStore.isVisible || taggingStore.isTagging) && (
        <TrackingElements
          parentId='root'
          categories={trackingElementsStore.getCategories()}
          errors={trackingElementsStore.getErrors}
          sessionMode={sessionStore.currentSessionMode.sessionMode}
          statuses={trackingElementsStore.statuses}
          updating={trackingElementsStore.updating}
          isPtuConnected={contextStore.isConnectedPtu}
        />
      )}
      {videoUploaderStateStore.isVisible && (
        <DisplayUploadStatus
          parentId='root'
          batTrackingVideo={videoUploaderStateStore.batTrackingVideo}
          compositeImages={videoUploaderStateStore.compositeImages}
          mainComponentUploadStatus={videoUploaderStateStore.mainComponentUploadStatus}
          measurementsAndMetadata={videoUploaderStateStore.measurementsAndMetadata}
          playVideo={videoUploaderStateStore.playVideo}
          playerPositioningData={videoUploaderStateStore.playerPositioningData}
          totalTimeRemaining={videoUploaderStateStore.totalTimeRemaining}
          isInternetConnectionAvailable={videoUploaderStateStore.isInternetConnectionAvailable}
        />
      )}
      {taggingStore.isTagging && <PlayVideo />}
    </Wrapper>
  );
});
